import React, { useState, memo } from 'react'
import Button from '../../../../atoms/Button/Button'
import { PosizioneLoghi1, PosizioneLoghi2, PosizioneLoghi3 } from '../../../../atoms/NewIcons'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import Link from 'next/link'
import useTrans from '../../../../../hooks/useTrans'
import { trackingGAEventProdotto } from '../../../../../utils/gtm'

const PosizioneStampa = memo(({ props, setStep, step, nPosizioni }) => {
  const t = useTrans()
  const [Posizionamento, setPosizionamento] = useState(
    props.values.posizioni?.length === 2 && props.values?.stesso_logo === false
      ? 3
      : props.values.posizioni?.length
  )
  return (
    <div className="posizione-stampa">
      <p className="posizione-stampa__description">
        {t('Seleziona la posizione di stampa che desideri configurare')}
      </p>
      <div className="posizione-stampa__dimensioni">
        {/* //! Aspettare che vengano resi disponibili i dati */}
        {/*
          <p className="posizione-stampa__dimesione">{t("Dimensioni Fronte")}: 280x280mm</p>
          <p className="posizione-stampa__dimesione">{t("Dimensioni Retro")}: 280x280mm</p>
        */}
      </div>
      <div className="posizione-stampa__options">
        <div
          className={`posizione-stampa__option ${
            Posizionamento === 1 && 'posizione-stampa__option--active'
          }`}
          onClick={(e) => {
            props.values.posizioni = [{}]
            props.setFieldValue('stesso_logo', true)
            props.values.stesso_logo = true
            setPosizionamento(1)
          }}
        >
          <FormRadio
            image={<PosizioneLoghi1 />}
            size="sm"
            label={t('1 Posizione')}
            checked={Posizionamento === 1 ? true : false}
          />
        </div>
        {/* Posizionamenti Precedente in base ai dati dell'api */}
        {/* {nPosizioni > 1 && ( */}
        <>
          <div
            className={`posizione-stampa__option ${
              Posizionamento === 2 && 'posizione-stampa__option--active'
            }`}
            onClick={(e) => {
              props.values.posizioni = [{}, {}]
              props.values.stesso_logo = true
              props?.setFieldValue('stesso_logo', true)
              setPosizionamento(2)
            }}
          >
            <FormRadio
              image={<PosizioneLoghi2 />}
              size="sm"
              label={t('2 Posizioni con stesso logo')}
              checked={Posizionamento === 2 ? true : false}
            />
          </div>
          <div
            className={`posizione-stampa__option ${
              Posizionamento === 3 && 'posizione-stampa__option--active'
            }`}
            onClick={(e) => {
              props.values.posizioni = [{}, {}]
              props?.setFieldValue('stesso_logo', false)
              props.values.stesso_logo = false
              setPosizionamento(3)
            }}
          >
            <FormRadio
              image={<PosizioneLoghi3 />}
              size="sm"
              label={t('2 Posizioni con loghi diversi')}
              checked={Posizionamento === 3 ? true : false}
            />
          </div>
        </>
      </div>
      <p className="posizione-stampa__contacts">
        {t('Se hai bisogno di stampare su più posizioni')}{' '}
        <span className="posizione-stampa__link">
          <Link href="/contatti">
            <a>{t('Contattaci')}</a>
          </Link>
          .
        </span>{' '}
      </p>
      {Posizionamento && (
        <Button
          size="large"
          responsive={true}
          variant="primary"
          label={t('Conferma posizione di stampa')}
          onClick={() => {
            setStep(step + 1)
            const first_articolo =
              props?.values?.prodotto?.articoli.length > 0
                ? props?.values?.prodotto?.articoli[0]
                : null
            trackingGAEventProdotto(
              'customization_start',
              'c_step1_posizione_stampa',
              undefined,
              first_articolo?.titolo || '',
              props?.values?.prodotto?.codice || ''
            )
          }}
        />
      )}
    </div>
  )
})

export default PosizioneStampa
